import { surveyInstance } from '..';

const getSurveyAnalytics = async (id) => {
  const { data } = await surveyInstance(`/answers/analytics/${id}`);
  return data;
};

export default getSurveyAnalytics;
